/*
 * @Author: Teemo Ding
 * @Date: 2021-09-15 11:30:26
 * @LastEditTime: 2021-09-22 09:29:45
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/Edit/Domain/index.tsx
 */
import { Button, Form, Input, Label } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { SSLStatusType } from '@/src/types/common/domain';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from '../css.module.less';

const { Item } = Form;

const Domain = ({ domain, confirmDomain, status }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [editing, setEditing] = useState(false);

  const handleCancelEdit = () => {
    setEditing(false);
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelDomainAndStatus.edit.domain')}>
      {domain && !editing ? (
        <div>{domain}</div>
      ) : (
        <Item
          name='domain'
          className={css.certificateItem}
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('salesChannelDomainAndStatus.edit.domain'),
              ),
            },
            {
              pattern:
                /^((?!-))(xn--)?[a-z0-9][a-z0-9-_]{0,61}[a-z0-9]{0,1}\.(xn--)?([a-z0-9\-]{1,61}|[a-z0-9-]{1,30}\.[a-z]{2,}(\.[a-z]{2,})?)$/,
              message: getI18n(
                'salesChannelDomainAndStatus.edit.thisfieldmustbeavalidURL',
              ),
            },
          ]}
          label={
            <Label
              title={getI18n('salesChannelDomainAndStatus.edit.domain')}
              rightSubTitle={getI18n(
                'salesChannelDomainAndStatus.edit.domainsubtitle',
              )}
            />
          }
          labelCol={{ span: 24 }}>
          <Input placeholder='e.g. example.com' size='large' />
        </Item>
      )}
      {status !== SSLStatusType.Verified ? (
        domain && !editing ? (
          <Button
            type='primary'
            onClick={() => setEditing(true)}
            className={css.primaryButton}
            ghost>
            {getI18n('salesChannelDomainAndStatus.edit.changeDomain')}
          </Button>
        ) : (
          <Button
            type='primary'
            onClick={() => confirmDomain(['domain'])}
            className={css.primaryButton}>
            {getI18n('general.confirm')}
          </Button>
        )
      ) : null}
      {editing && (
        <Button onClick={handleCancelEdit}>{getI18n('general.cancel')}</Button>
      )}
    </SectionWrapper>
  );
};

export default Domain;
